import { useCallback, useState } from 'react'

/**
 * An on/off choice about the layout — a folded menu, a hidden panel — remembered in this browser.
 *
 * Remembering is a nicety: with storage blocked the choice still holds for the visit.
 */
export function usePersistedFlag(key: string, initial: boolean): [boolean, () => void] {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key)
      return stored === null ? initial : stored === 'on'
    } catch {
      return initial
    }
  })

  const toggle = useCallback(() => {
    setValue((current) => {
      try {
        localStorage.setItem(key, current ? 'off' : 'on')
      } catch {
        // Storage blocked: the toggle still works for this visit.
      }
      return !current
    })
  }, [key])

  return [value, toggle]
}
